import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Card } from '@scentregroup/ui'
import { useCountryContext, useEvolvedContext } from '../context'
import withCentreSelector from '../containers/with-centre-selector'
import Markdown from '../components/markdown/'
import UnifiedHeader from '../components/unified-header'
import NationalFooter from '../components/national-footer'
import { UniversalFooter } from '../components/universal-footer'
import PageLanding from '../components/page-landing'
import pagesHoc from './pages-hoc'

const Privacy = ({ homePageInfo }) => {
  const country = useCountryContext()
  const isEvolved = useEvolvedContext()
  return (
    <Fragment>
      <UnifiedHeader />
      <PageLanding heading="Privacy Policy" dataTestId="page-title">
        <Card>
          <Markdown content={homePageInfo.privacyPolicy} />
        </Card>
      </PageLanding>
      {isEvolved ? (
        <UniversalFooter Link={Link} country={country} />
      ) : (
        <NationalFooter />
      )}
    </Fragment>
  )
}

Privacy.propTypes = {
  homePageInfo: PropTypes.object,
}

const getMetaData = ({ centres }) => ({
  title: `National Website Privacy Policy | Westfield ${centres[0].country}`,
  description: `Your privacy is important to us and we are committed to the protection of personal information. Read more on Westfield ${centres[0].country}'s website privacy policy here.`,
})

export default withCentreSelector(pagesHoc(Privacy, getMetaData))
